import { useCallback } from "react";
import { useListAccessibleOrganizationsQuery } from "~/shared/api/organization/organization.grpc";
import { isOwnType, type Id } from "~/shared/lib/holding-type";

/**
 * Whether the user may change a type: its owner is the company, or an organization the user has the backend's write
 * right on (custom access included). Requests then name the type's owner, which the backend authorizes.
 * Truck types need can_manage on trucks, container types can_edit on container types, as the backend checks.
 */
export function useCanWriteType(resource: "truck" | "container_type", companyId: Id) {
  const { currentData } = useListAccessibleOrganizationsQuery(
    { resource, action: resource === "truck" ? "can_manage" : "can_edit" },
    { skip: !companyId },
  );
  return useCallback(
    (type: { ownerOrganizationId?: Id }) =>
      isOwnType(type, companyId) ||
      !!currentData?.organizations.some(
        (org) => String(org.id) === String(type.ownerOrganizationId),
      ),
    [companyId, currentData],
  );
}
